var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9649 11.9404H12.7549L17.7449 16.9404L16.2549 18.4304L11.2549 13.4404V12.6504L10.9849 12.3704C9.84488 13.3504 8.36488 13.9404 6.75488 13.9404C3.16488 13.9404 0.254883 11.0304 0.254883 7.44043C0.254883 3.85043 3.16488 0.94043 6.75488 0.94043C10.3449 0.94043 13.2549 3.85043 13.2549 7.44043C13.2549 9.05043 12.6649 10.5304 11.6849 11.6704L11.9649 11.9404ZM2.25488 7.44043C2.25488 9.93043 4.26488 11.9404 6.75488 11.9404C9.24488 11.9404 11.2549 9.93043 11.2549 7.44043C11.2549 4.95043 9.24488 2.94043 6.75488 2.94043C4.26488 2.94043 2.25488 4.95043 2.25488 7.44043Z",
    fill: "#37474F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6c611f3a51ac6d6a9a56f0dc9fee78ed.svg";
export { ForwardRef as ReactComponent };